<!-- UserLogin.vue -->
<template>
  <div class="login-container">
    <div class="header">
      <h1>User Login</h1>
    </div>
    
    <div class="login-form">
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="user_mobile">Mobile Number</label>
          <input 
            type="text" 
            id="user_mobile"
            v-model="UserLogin.user_mobile" 
            placeholder="Enter your mobile number"
            required
          />
        </div>
        
        <div class="form-group">
          <label for="user_password">Password</label>
          <input 
            type="password" 
            id="user_password"
            v-model="UserLogin.user_password" 
            placeholder="Enter your password"
            required
          />
        </div>
        
        <button type="submit" :disabled="isLoading" class="login-btn">
          {{ isLoading ? 'Logging in...' : 'Login' }}
        </button>
      </form>
      
      <div v-if="message" :class="messageClass">
        {{ message }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'UserLogin',
  data() {
    return {
      UserLogin: {
        user_mobile: '',
        user_password: ''
      },
      isLoading: false,
      message: '',
      messageClass: ''
    }
  },
  methods: {
    async handleLogin() {
      this.isLoading = true
      this.message = ''
      
      try {
        const response = await fetch('https://e01.yeapps.com/medi360/user_login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            user_mobile: this.UserLogin.user_mobile,
            user_password: this.UserLogin.user_password
          })
        })
        
        const data = await response.json()
        
        if (data.success) {
          this.message = 'Login successful! Redirecting...'
          this.messageClass = 'success-message'
          
          // Store comprehensive user information
          const userData = {
            isLoggedIn: true,
            userId: data.user_id || '',
            userName: data.user_name || '',
            userMobile: data.user_mobile || this.UserLogin.user_mobile,
            userAddress: data.user_address || '',
            userEmail: data.user_email || '',
            status: data.status || 'active'
          }
          
          // Store in localStorage for persistence
          Object.keys(userData).forEach(key => {
            localStorage.setItem(key, userData[key].toString())
          })
          
          console.log('User data stored:', userData)
          
          // Redirect after 1 second
          setTimeout(() => {
            this.$router.push('/pharmacies')
          }, 1000)
        } else {
          this.message = data.error || 'Password mismatch'
          this.messageClass = 'error-message'
        }
      } catch (error) {
        console.error('Login error:', error)
        this.message = 'Network error. Please try again.'
        this.messageClass = 'error-message'
      } finally {
        this.isLoading = false
      }
    }
  }
  // created() {
  //   // Check if user is already logged in
  //   const isLoggedIn = localStorage.getItem('isLoggedIn')
  //   if (isLoggedIn === 'true') {
  //     this.$router.push('/pharmacies')
  //   }
  // }
}
</script>

<style scoped>
.login-container {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background-color: #000;
  color: #e2e2e2;
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  position: relative;
}

.header {
  display: flex;
  align-items: center;
  padding: 16px;
  position: sticky;
  top: 0;
  background-color: #000;
  z-index: 10;
  border-bottom: 1px solid #333;
}

.header h1 {
  margin: 0;
  color: #3aa757;
  font-size: 18px;
  flex: 1;
  text-align: center;
}

.login-form {
  padding: 24px 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #e2e2e2;
  font-weight: 500;
  font-size: 14px;
}

.form-group input {
  width: 100%;
  padding: 14px;
  border: 1px solid #444;
  border-radius: 7px;
  background-color: #1a1a1a;
  color: #e2e2e2;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

.form-group input:focus {
  outline: none;
  border-color: #3aa757;
}

.form-group input::placeholder {
  color: #999;
}

.login-btn {
  width: 100%;
  background-color: #3aa757;
  color: #e2e2e2;
  border: none;
  border-radius: 7px;
  padding: 16px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 10px;
}

.login-btn:hover:not(:disabled) {
  background-color: #308de4;
}

.login-btn:disabled {
  background-color: #333;
  cursor: not-allowed;
  opacity: 0.7;
}

.success-message {
  color: #3aa757;
  text-align: center;
  margin-top: 16px;
  padding: 12px;
  background-color: #1a1a1a;
  border: 1px solid #3aa757;
  border-radius: 7px;
  font-size: 14px;
}

.error-message {
  color: #e74c3c;
  text-align: center;
  margin-top: 16px;
  padding: 12px;
  background-color: #1a1a1a;
  border: 1px solid #e74c3c;
  border-radius: 7px;
  font-size: 14px;
}
</style>